class CustomBlogSlider {
  constructor(container) {
    this.container = container;
    this.activeWrapper = container.querySelector('.active-blog-wrapper');
    this.sidebarCarousel = container.querySelector('.blog-sidebar-carousel');
    this.activePosts = container.querySelectorAll('.active-blog-post');
    this.sidebarCards = container.querySelectorAll('.sidebar-blog-card');
    
    this.currentIndex = 0;
    this.totalPosts = this.activePosts.length;
    this.carouselInstance = null;
    this.isDesktop = window.innerWidth >= 801;
    this.hoverTimeout = null;

    this.init();
  }

  init() {
    this.waitForCarousel();
    this.handleResize();
  }

  waitForCarousel() {
    let attempts = 0;
    const maxAttempts = 30;
    
    const checkCarousel = setInterval(() => {
      attempts++;
      
      if (this.sidebarCarousel && this.sidebarCarousel.carousel) {
        clearInterval(checkCarousel);
        this.setupCarousel();
        this.bindEvents();
      } else if (attempts >= maxAttempts) {
        clearInterval(checkCarousel);
        console.warn('Blog slider: Carousel not initialized after maximum attempts');
        this.bindEvents(); 
      }
    }, 100);
  }

  setupCarousel() {
    this.carouselInstance = this.sidebarCarousel.carousel;
    
    if (!this.carouselInstance) return;

    // Update active post when carousel moves
    this.carouselInstance.on('moved', (splide, newIndex) => {
      if (this.isDesktop) {
        this.updateActivePostFromCarouselIndex(newIndex);
      }
    });

    // Set initial active post on mount
    this.carouselInstance.on('mounted', () => {
      if (this.isDesktop) {
        const initialIndex = this.carouselInstance.index;
        this.updateActivePostFromCarouselIndex(initialIndex);
      }
    });

    setTimeout(() => {
      if (this.carouselInstance && this.carouselInstance.refresh) {
        this.carouselInstance.refresh();
      }
    }, 100);
  }

  updateActivePostFromCarouselIndex(carouselIndex) {
    // Get the slide at the current carousel index
    const slides = this.carouselInstance.Components.Slides.get();
    
    if (slides && slides[carouselIndex]) {
      const slideElement = slides[carouselIndex].slide;
      const card = slideElement.querySelector('.sidebar-blog-card');
      
      if (card) {
        const articleIndex = parseInt(card.dataset.articleIndex);
        this.updateActivePost(articleIndex);
      }
    }
  }

  bindEvents() {
    // Click and hover events for sidebar cards
    this.sidebarCards.forEach((card) => {
      const articleIndex = parseInt(card.dataset.articleIndex);
      
      card.addEventListener('click', (e) => {
        const articleUrl = card.dataset.articleUrl;
        if (articleUrl) {
          window.location.href = articleUrl;
        }
      });

      // Add hover events for desktop
      if (this.isDesktop) {
        card.addEventListener('mouseenter', () => {
          clearTimeout(this.hoverTimeout);
          this.updateActivePost(articleIndex);
        });
      }
    });

    // Click events for active posts
    this.activePosts.forEach((post) => {
      const link = post.querySelector('.active-blog-link');
      if (link) {
        link.addEventListener('click', (e) => {
          const href = link.getAttribute('href');
          if (href) {
            window.location.href = href;
          }
        });
      }
    });
  }

  updateActivePost(articleIndex) {
    if (articleIndex < 0 || articleIndex >= this.totalPosts) {
      return;
    }

    if (articleIndex === this.currentIndex) {
      return;
    }

    if (this.isDesktop) {
      // Remove active class from all posts
      this.activePosts.forEach(post => {
        post.classList.remove('is-active');
      });

      // Find and activate the post with matching article index
      const targetPost = Array.from(this.activePosts).find(post => {
        return parseInt(post.dataset.articleIndex) === articleIndex;
      });

      if (targetPost) {
        targetPost.classList.add('is-active');
        this.currentIndex = articleIndex;
      }
    }
  }

  handleResize() {
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const wasDesktop = this.isDesktop;
        this.isDesktop = window.innerWidth >= 801;

        if (wasDesktop !== this.isDesktop) {
          // Re-bind events with new desktop state
          this.bindEvents();
          
          if (this.carouselInstance) {
            this.carouselInstance.refresh();
          }
        }
      }, 250);
    });
  }
}

function initBlogSliders() {
  const blogSliders = document.querySelectorAll('.custom-blog-slider');
  
  blogSliders.forEach((slider) => {
    if (!slider.dataset.initialized) {
      slider.dataset.initialized = 'true';
      new CustomBlogSlider(slider);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBlogSliders);
} else {
  initBlogSliders();
}

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const slider = event.target.querySelector('.custom-blog-slider');
    if (slider) {
      slider.dataset.initialized = 'false';
      setTimeout(() => {
        new CustomBlogSlider(slider);
      }, 500);
    }
  });
}